import {
  deleteMultiRequest,
  deleteRequest,
  getRequest,
  getRequestBlob,
  postRequest,
  postRequestBlob,
} from "./RequestConfig";

export const fetchAllSurvey = async () => {
  try {
    const response = await getRequest("survey/all");
    return response;
  } catch (e) {
    console.log(e);
  }
};
export const fetchAllVehicleDetails = async (url) => {
  try {
    const response = await getRequest(url);
    return response;
  } catch (e) {
    console.log(e);
  }
};
export const getSingleSurveyDetails = async (item) => {
  try {
    const response = await getRequest(`survey?surveyId=${item}`);
    return response;
  } catch (e) {
    console.log(e);
  }
};
export const vinValidation = async (payload) => {
  try {
    const response = await postRequest(`part-details/decodeVin`, payload);
    return response;
  } catch (e) {
    console.log(e);
  }
};

export const deleteSingleSurvey = async (surveyId) => {
  try {
    const response = await deleteRequest(`survey?surveyId=${surveyId}`);
    return response;
  } catch (e) {
    console.log(e);
  }
};

export const getStoreDetails = async (storeId) => {
  try {
    const response = await getRequest(`store?storeId=${storeId}`);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getSurveyWithFilter = async (name, createdDate, revisedDate) => {
  try {
    const response = await getRequest(
      `survey/all?${
        name === "created"
          ? "createdTs=" + createdDate
          : "lastUpdatedTs=" + revisedDate
      }`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getRequestBlobDisplay = async (payload) => {
  try {
    const response = await postRequestBlob(`export/pdf`, payload);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getRequestBlobPrint = async (payload) => {
  try {
    const response = await postRequestBlob(`export/pdf`, payload);
    return response;
  } catch (error) {
    throw error
  }
};

export const getRequestBlobStock = async (selectedSurveyId) => {
  try {
    const response = await getRequestBlob(
      `api/export/stock?surveyId=${selectedSurveyId}`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getRequestBlobExcel = async (selectedSurveyId) => {
  try {
    const response = await getRequestBlob(
      `api/export/excel?surveyId=${selectedSurveyId}`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getAllStates = async () => {
  try {
    const response = await getRequest(`countries`);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getSingleSurvey = async (selectedSurveyId) => {
  try {
    const response = await getRequest(
      `vehicle/all?surveyId=${selectedSurveyId}`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getSingleVehiclePartsDetails = async (selectedVehicleId) => {
  try {
    const response = await getRequest(
      `part-details/all?vehicleId=${selectedVehicleId}`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getSingleVehicleDetails = async (vehicleId) => {
  try {
    const response = await getRequest(`vehicle?vehicleId=${vehicleId}`);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const decodeVinNumber = async (payload) => {
  try {
    const response = await postRequest(`part-details/decodeVin`, payload);
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const addFindehicle = async (payload) => {
  try {
    const response = await postRequest("vehicle/addvehicleparts", payload);
    return response;
  } catch (error) {
    return error
  }
};
export const addDuplicateVehicle = async (payload) => {
  try {
    const response = await postRequest("vehicle", payload);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getAllStore = async () => {
  try {
    const response = await getRequest("store/all");
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const createStore = async (payload) => {
  try {
    const response = await postRequest("store", payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createSurvey = async (payload) => {
  try {
    const response = await postRequest("survey", payload);
    return response;
  } catch (error) {
    console.log(error);
    return error
  }
};

export const deleteStore = async (storeId) => {
  try {
    const response = await deleteRequest(`store?storeId=${storeId}`);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const fetchAllFleets = async () => {
  try {
    const response = await getRequest("fleet/all");
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const getSingleFleet = async (id) => {
  try {
    const response = await getRequest(`fleet?fleetId=${id}`);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const deleteSingleFleet = async (fleetId) => {
  try {
    const response = await deleteRequest(`fleet?fleetId=${fleetId}`);
    return response;
  } catch (error) {
    console.log(error);
  }
};

export const createFleet = async (payload) => {
  try {
    const response = await postRequest("fleet", payload);
    return response;
  } catch (error) {
    throw error;
  }
};

export const partDetails = async (competitorPartNumber) => {
  try {
    const response = await getRequest(
      `part-details/interchange?partNumber=${competitorPartNumber}`
    );
    return response;
  } catch (error) {
    console.log(error);
  }
};
export const deleteSingleOrMultipleVehicle = async (payload) => {
  try {
    const response = await deleteMultiRequest(`vehicle`, payload);
    return response;
  } catch (e) {
    console.log(e);
  }
};
export const deleteSingleOrMultiplePart = async (payload) => {
  try {
    const response = await deleteMultiRequest(`part-details`, payload);
    return response;
  } catch (e) {
    console.log(e);
  }
};
export const pastePartsToVehicle = async (payload) => {
  try {
    const response = await postRequest("part-details", payload);
    return response;
  } catch (error) {
    
    console.log(error);
    throw error
  }
};

export const getAllDcCode = async () => {
  try {
    const response = await getRequest("location/dccode");
    return response;
  } catch (error) {
    console.log(error);
  }
};
